import { useEffect } from 'react';
import './UploadProgress.less';
import loading from '@/assets/texture/modelloading.gif';
import { ConfigProvider, Progress } from 'antd';
import modelImg from '@/assets/home/modelImg.png';

export default function UploadProgress(props) {
  useEffect(() => {}, []);
  return (
    <div className="upload-progress">
      <img
        className="upload-loading"
        style={{
          width: props.imageSize ? 72 : '',
          height: props.imageSize ? 66 : '',
          marginBottom: props.imageSize ? 8 : '',
        }}
        src={props.gifLoading ? loading : modelImg}></img>
      {!props.hideTitle && (
        <span className="upload-progress-title">{props.title || 'Loading'}</span>
      )}
      <ConfigProvider
        theme={{
          components: {
            Progress: {
              defaultColor: '#A0F00F',
              remainingColor: '#313131',
            },
          },
        }}>
        <Progress style={{ width: 300 }} showInfo={false} percent={props.percent}></Progress>
      </ConfigProvider>
    </div>
  );
}
